module.exports = __webpack_public_path__ + "img/Silver.3d8a6065.png";